import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Select, ThemeContext } from 'grommet';
import { Box, Text } from 'components/Wrapped';

export const ValueLabel = ({ label, size = 'small', placeholder = '...', pad = { vertical: 'xsmall', horizontal: 'small' } }) => {
  return (
    <Box pad={pad} fill={true}>
      <Text color={label ? 'white' : '#B4B6B7'} weight={600} size={size}>
        {label ? label : placeholder}
      </Text>
    </Box>
  );
};

const WrappedSelect = ({
  options,
  defaultValue,
  onChange,
  labelKey,
  valuePad,
  valueSize,
  placeholder,
  borderRadius = '12px',
  background = '#000D14',
  borderColor,
  margin = { bottom: 'small' },
  valueLabel,
  ...rest
}) => {
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const getLabel = () => {
    return labelKey ? _.get(value, labelKey) : value;
  };

  return (
    <ThemeContext.Extend
      value={{
        select: {
          control: {
            extend: `background-color: #000D14; border-radius: ${borderRadius}; border-color: var(--${
              borderColor ? borderColor : background
            });`,
          },
          icons: {
            color: 'white',
          },
          options: {
            container: {
              background,
            },
          },
        },
      }}
    >
      <Box pad="none" margin={margin} round={false}>
        <Select
          value={value}
          options={options}
          focusIndicator={false}
          onChange={({ option, ...rest }) => {
            setValue(option);
            onChange(option);
          }}
          children={(option, index, options, state) => {
            return (
              <Box
                pad={{ horizontal: 'small', vertical: 'xsmall' }}
                background={state.selected || state.active ? '#46B08E' : '#222E34'}
                round={false}
              >
                <Text color={state.selected || state.active ? 'white' : '#B4B6B7'} size="12px" weight={600}>
                  {labelKey ? option[labelKey] : option}
                </Text>
              </Box>
            );
          }}
          valueLabel={valueLabel ? valueLabel : <ValueLabel label={getLabel()} pad={valuePad} size={valueSize} placeholder={placeholder} />}
          labelKey={labelKey}
          dropHeight="medium"
          {...rest}
        />
      </Box>
    </ThemeContext.Extend>
  );
};

WrappedSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
};

export default WrappedSelect;
